module.exports = __webpack_public_path__ + "img/1696559843313-image.jpg.0c7cc50c.webp";